import {
  RawDraftContentBlock,
  StylePrefix,
  getInlineStylesValue,
} from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import { SerializedLexicalNode } from 'lexical/LexicalNode';
import { CustomListItemNode, SerializedCustomListItemNode } from 'modules/Lexical/nodes/CustomListItemNode';
import { RawDraftContentBlockData } from '../types';

export function createListItemNode(
  contentBlock: RawDraftContentBlock,
  children: SerializedLexicalNode[] = [],
): SerializedCustomListItemNode {
  const { inlineStyleRanges, depth, data } = contentBlock;
  const styles = inlineStyleRanges.map(range => range.style);
  const { lineHeight } = data as RawDraftContentBlockData;

  return {
    children,
    direction: 'ltr',
    type: CustomListItemNode.getType(),
    version: 1,
    indent: depth,
    lineHeight,
    format: '',
    checked: undefined,
    value: 0,
    fontSize: getInlineStylesValue(styles, StylePrefix.FONT_SIZE, 'number'),
  };
}
